import { postCustomEvent } from './postCustomEvent';

export const customEventsHttpClient = {
    post: postCustomEvent,
};
